import { render } from "./ChangeUsersToGroupsForm.vue?vue&type=template&id=0e38123c"
import script from "./ChangeUsersToGroupsForm.vue?vue&type=script&lang=js"
export * from "./ChangeUsersToGroupsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__